import { addLoginParams, closeFullScreen } from '@utils';
import BaseVue from '@/helper/BaseVue';
import { Component } from 'vue-property-decorator';
import { isNotEmpty, getEnv } from '@tencent/slug-function';
const { isMSDK } = getEnv();
@Component
class JumpLinksMixin extends BaseVue {
  /**
   * url跳转处理
   * 外链跳转默认自动关闭全屏
   * 检测到是 https://sy.qq.com/gp/ 开头的，自动转为路由跳转形式
   * @param url 要跳转的url
   * @param isCloseFullScreen 是否要关闭全屏
   */
  public jumpLinks(url: string, isCloseFullScreen: Boolean = true) {
    if (/^https:\/\/sy\.qq\.com\/gp\//.test(url)) {
      const routerPath = url.match(/\/gp\/.*/);
      if (routerPath !== null && isNotEmpty(routerPath[0])) {
        this.$router.push({ path: routerPath[0] });
        return;
      }
    }
    if (isCloseFullScreen && isMSDK) {
      try {
        closeFullScreen();
      } catch {
        console.log('关闭全屏失败');
        Sentry.captureMessage(new Error('关闭全屏失败'));
      }
    }
    window.location.href = addLoginParams(url);
  }
}

export default JumpLinksMixin;
